/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import DurationInput from './DurationInput/index'
import React from 'react'
import TemplateSelect from './TemplateSelect/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/TypeAndDuration/Content"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Type"
/>
</div>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<TemplateSelect
  viewPath={`${viewPath}/TemplateSelect`}
/>
</div>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 className="views-block"
>
<DurationInput
  viewPath={`${viewPath}/DurationInput`}
 height="30px"
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}